import { useQuery } from "react-query";
import { fetchServerVersion } from "../api/fetchServerVersion";

export const useServerVersion = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["serverVersion"],
    queryFn: fetchServerVersion,
    staleTime: Infinity,
    retry: false,
  });

  return { serverVersion: data, isLoading, isError };
};
